import React, { useEffect, useState } from "react";
import "./Category_Carousel.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/pagination";

import {
  Autoplay,
  EffectCoverflow,
  Navigation,
  Pagination,
} from "swiper/modules";
import { BASE_URL } from "../../../constant";
import axios from "axios";

// Images
import langotImage from "../../../images/langot.png";
import Zabli from "../../../images/zabli.png";
import Wraps from "../../../images/wraps.png";
import Topri from "../../../images/topri.png";
import { useNavigate } from "react-router-dom";

const categories2 = [
  { label: "Langot", image: langotImage },
  { label: "Zabli", image: Zabli },
  { label: "Wraps", image: Wraps },
  { label: "Topri", image: Topri },
];
const CategoryCarousel = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/category/all-unhide`);
        setCategories(response.data);
      } catch (error) {
        console.error("Error fetching Categories:", error);
      }
    };

    fetchCategories();
  }, []);

  const handleCardClick = (category) => {
    setSelectedCategory(category);
  };

  return (
    <div>
      {categories.length > 0 ? (
        <div className="category-carousel">
          <Swiper
            effect={"coverflow"}
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={"auto"}
            initialSlide={Math.floor(categories.length / 2)}
            coverflowEffect={{
              rotate: 0,
              stretch: 0,
              depth: 120,
              modifier: 2.5,
              slideShadows: false,
            }}
            modules={[EffectCoverflow, Navigation, Autoplay, Pagination]}
            navigation
            pagination={{
              el: ".swiper-pagination",
              clickable: true,
            }}
            speed={800}
            autoplay={{
              delay: 1500,
              disableOnInteraction: true,
              pauseOnMouseEnter: true,
            }}
            className="cat-swiper cursor-pointer"
            style={{ cursor: "pointer" }}
          >
            {categories.map((category, index) => (
              <SwiperSlide
                key={index}
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                className="cat-swiper-slide"
                onClick={() => handleCardClick(category)}
              >
                <div className="category-card">
                  <img
                    src={category.categoryImage}
                    alt={category.categoryName}
                    className="category-image"
                  />
                  <p className="category-label">{category.categoryName}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div
            className="modal fade"
            id="exampleModal"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content subcategory-modal-container">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    {selectedCategory?.categoryName || "Category Name"}
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body subcategory-modal">
                  {selectedCategory?.subcategoryList?.length > 0
                    ? selectedCategory.subcategoryList.map((subcategory) => (
                        <div
                          key={subcategory.subCategoryId}
                          className="subcategory-card"
                          onClick={() => {
                            navigate(
                              `/shop?category=${selectedCategory?.categoryName}&subcategory=${subcategory.subCategoryName}`
                            );
                            window.location.reload();
                          }}
                        >
                          {subcategory.subCategoryNameImage ? (
                            <img
                              src={subcategory.subCategoryNameImage}
                              alt={subcategory.subCategoryName}
                              className="img-fluid"
                            />
                          ) : (
                            <div className="placeholder-image">
                              <img src="https://static.vecteezy.com/system/resources/previews/022/014/063/original/missing-picture-page-for-website-design-or-mobile-app-design-no-image-available-icon-vector.jpg" />
                            </div>
                          )}
                          <p className="subcategory-name">
                            {subcategory.subCategoryName}
                          </p>
                        </div>
                      ))
                    : "No subcategories available."}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <p>Loading categories...</p>
      )}
    </div>
  );
};

export default CategoryCarousel;
